import _ from 'lodash';
import { nanoid } from 'nanoid';
import { createSelector } from 'reselect';

import { SYSTEM_PROPERTIES } from 'constants/properties';

import { getCompany } from './company.selectors';
import { selectMasterCompanyPropertiesNew } from './crmFeatures.selectors';

const selectRootBusinessDays = createSelector(getCompany, ({ businessDays }) => businessDays);

export const selectBusinessDays = createSelector(selectRootBusinessDays, ({ businessDays }) => {
  const {
    internalHolidays = [],
    preciseBusinessDays,
    generalBusinessDays,
    globalHolidays,
    generalOpenFederalHolidays = [],
    preciseOpenFederalHolidays = [],
    observeFederalHolidays = false,
  } = businessDays?.businessSchedule || {};

  // internalHolidays already holds every company holiday, past ones included.
  const companyInternalHolidays = _.map(internalHolidays, ({ date, name }) => ({
    date,
    name,
    id: nanoid(),
  }));

  return {
    internalHolidays: companyInternalHolidays,
    preciseBusinessDays,
    generalBusinessDays,
    globalHolidays,
    generalOpenFederalHolidays,
    preciseOpenFederalHolidays,
    observeFederalHolidays,
  };
});

export const selectPotentialBusinessDays = createSelector(
  selectRootBusinessDays,
  ({ potentialBusinessDays }) => potentialBusinessDays,
);

// A missing or malformed property keeps the closing dates on the Precise calendar only.
const selectCountSaturdayForFunding = createSelector(
  selectMasterCompanyPropertiesNew,
  properties => {
    const property = _.find(properties, {
      propertyName: SYSTEM_PROPERTIES.ALWAYS_COUNT_SATURDAY_FOR_FUNDING,
    });

    return _.toLower(property?.propertyValue) === 'true';
  },
);

// Closing dates run on the Precise calendar, so a federal holiday the company is open on there is
// not a closure for them.
export const selectClosingBusinessDays = createSelector(
  [selectBusinessDays, selectCountSaturdayForFunding],
  (businessDays, countSaturdayForFunding) => ({
    ...businessDays,
    globalHolidays: businessDays.globalHolidays?.filter(
      ({ federalHoliday }) => !businessDays.preciseOpenFederalHolidays.includes(federalHoliday),
    ),
    countSaturdayForFunding,
  }),
);
